export const FIELD_PLAN_ID = 'oneplace-field';
export const FIELD_PLAN_ID_ANNUAL = 'oneplace-field--annual-subscription';
export const PROMAPPER_PLAN_ID = 'promapper';
